import { SkeletonLoader } from '#components/Feedback/SkeletonLoader';
import { TableCell, TableRow } from '../TableRows/style';

export const LoadingIndicator = ({
  loading,
  columnsLength,
}: {
  loading: boolean;
  columnsLength: number;
}) => {
  if (!loading) {
    return null;
  }

  return Array.from({ length: 6 }).map((_, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <TableRow key={index}>
      <TableCell verticalAlign="middle" colSpan={columnsLength}>
        <SkeletonLoader />
      </TableCell>
    </TableRow>
  ));
};
